import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  PeriodFilterValue,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import dayjs from "dayjs";

export const PERIOD_ID = "period";

export const DEFUALT_PERIOD_VALUE: FilterValue = {
  filterId: PERIOD_ID,
  value: "period=7days",
};

export function usePeriodFilter(filterValues: FilterValue[]): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = DEFUALT_PERIOD_VALUE;

  const today = dayjs().format("YYYY-MM-DD");
  const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  const filterValue = filterValues.find(
    (value) => value.filterId === PERIOD_ID
  ) as PeriodFilterValue;

  return {
    inputType: InputType.Select,
    filterType: FilterType.Filter,
    id: PERIOD_ID,
    title: t("periodString"),
    options: [
      {
        value: "period=7days",
        title: t("last7DaysString"),
      },
      {
        value: "period=4weeks",
        title: t("last4WeeksString"),
      },
      {
        value: "period=custom",
        title: t("customTitleString"),
        startDate: filterValue?.startDate ?? yesterday,
        endDate: filterValue?.endDate ?? today,
      },
    ],
    enabled: true,
    defaultValue,
  };
}
